// extracted by mini-css-extract-plugin
export default {"layout":"_7226c4652c _303342b44f e2949e8286","h_slide":"_4781d44855","category":"_64eb5e89ea _50bef168e2 de2e10023a"};